/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ArrowAngleRightDownIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA/UlEQVR4nO2TQUoDUQyG0311ZcELuBf3ruxi0En+tPCatF5FD+ARRG/gCXShgghu24J6BQW78QCWN9pSQZlOmaEK/SC7vHwveS9EK4rC6vcCu6OqEPWPGCvB8kbE8PdMIrJWjUD9OQqA3nZFAjv7GtNRXq6onQj8Mk27G3MLRDrNKGDYS96YBHb1eRnrF5PAbjOJ2gUR1X7LS0JosNqgsOSg3d0StdFEkiSH66VLANtl+Ft2EP7KsOO01dkJIdR/kgh8uFAnrH4z2Y15g9UeqAgpbE/UTxn+ON2TMgV5fHsH2NN+CJtUFsm/LT67L/EHRRmVjaifs/p1JcX/DGOPILXdqFlZeQAAAABJRU5ErkJggg==)
 */
export const ArrowAngleRightDownIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21.7 16.7a1 1 0 0 0 0-1.4l-5-5a1 1 0 0 0-1.4 1.4l3.29 3.3H13a7 7 0 0 1-7-7V4a1 1 0 1 0-2 0v4a9 9 0 0 0 9 9h5.59l-3.3 3.3a1 1 0 0 0 1.42 1.4l5-5Z"
        className={colorClass}
      />
    </svg>
  );
};
